import {
  Card,
  HStack,
  Stack,
  Text,
  VStack,
  useColorModeValue,
  Tooltip,
  Avatar,
  IconButton,
} from '@chakra-ui/react';
import React, { FC, useEffect, useState } from 'react';
import { useFetch } from 'use-http';
import { api, makeHeaders } from '../../util/api';
import Loading from '../Misc/Loading';
import { ERROR_MESSAGE, useNotify } from '../../hooks/useNotify';
import { useParams } from 'react-router';
import { Survey, SurveyStatus } from './types';
import { FiEdit, FiSettings } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { formatDate } from '../../util/string';
import SurveyResponses from './SurveyResponses';
import { useSelector } from 'react-redux';
import { selectIsAdmin } from '../../store/slices/User/selectors';

const SurveyDetails: FC = () => {
  const notify = useNotify();
  const { id } = useParams();
  const [survey, setSurvey] = useState<null | Survey>(null);
  const isAdmin = useSelector(selectIsAdmin);

  const {
    error,
    cache,
    loading,
    response,
    get,
  } = useFetch(`${api}/surveys`, makeHeaders());

  const refreshSurvey = async () => {
    cache.clear();
    const survey = await get(`/${id}`);
    if (!error && response.ok && survey) {
      setSurvey(survey);
    } else {
      notify(ERROR_MESSAGE, 'error');
    }
  };

  useEffect(() => {
    refreshSurvey();
  }, []); // eslint-disable-line

  return (
    <Stack maxW='container.lg'>
      <Card p={4} mb={2} variant='outline'>
        <Loading isLoading={loading} dense />
        {!loading && (
          <HStack gap={4}>
            <Avatar size='lg' />
            <VStack align='start' w='full' mb={3} gap={0}>
              <Text
                fontSize='xl'
                fontWeight='semibold'
              >
                {survey?.title}
              </Text>
              <Text fontSize='xs' color='GrayText'>
                Creada el {formatDate(survey?.createdAt)}
              </Text>
            </VStack>
            {isAdmin && (
              <>
                <Tooltip label='Configurar encuesta'>
                  <IconButton
                    isRound
                    isDisabled={!survey || survey.status !== SurveyStatus.PUBLISHED}
                    aria-label='Configurar encuesta'
                    colorScheme='gray'
                    onClick={() => { }}
                    icon={<FiSettings />}
                    as={Link}
                    to={`/encuestas/${survey?.id}/editar`}
                  />
                </Tooltip>
                <Tooltip label='Responder encuesta'>
                  <IconButton
                    isRound
                    isDisabled={!survey || survey.status !== SurveyStatus.PUBLISHED}
                    aria-label='Responder encuesta'
                    colorScheme='gray'
                    onClick={() => { }}
                    icon={<FiEdit />}
                    as={Link}
                    to={`/encuestas/${survey?.id}/aplicar`}
                  />
                </Tooltip>
              </>
            )}
          </HStack>
        )}
      </Card>

      <Card
        variant='outline'
        p={4}
        bg={useColorModeValue('gray.50', 'gray.700')}
      >
        <Text fontWeight='bold' color='gray.500' textTransform='uppercase' fontSize='xs' mb={3}>Respuestas de la encuesta</Text>
        <SurveyResponses survey={survey} />
      </Card>
    </Stack>
  )
};

export default SurveyDetails;
